import React from 'react';

export default class GraphPerson extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let items = [];
    let total = 0;


    this.props.items.map((item) => {
      total += item.muertos;
    });

    let percent = (this.props.item.muertos * 100)/total;
    console.log("pintados")
    let percentgroup = Math.round((percent * 20)/100);

    for(var i = 0; i < 24 - percentgroup; i++) {
      items.push(<div className="persona-verde"></div>);
    }
    for(var i = 0; i < percentgroup; i++) {
      items.push(<div className="persona-roja "></div>);
    }

    return (
      <div className="columns small-6 fallecido">
        <div className="persons-container">
          {items}
        </div>
        <h1>{this.props.item.muertos}</h1> <h3>personas murieron en el terremoto según estadísticas de la época</h3>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./client/GraphPerson.js
 **/